import { useNavigate } from 'react-router-dom'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import type { Step4FormValues } from '../../../containers/sme/Step4Form'
import { Step4Form } from '../../../containers/sme/Step4Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'

export const Step4 = () => {
  const navigate = useNavigate()

  const handleSubmit = (values: Step4FormValues) => {
    console.log(values)
    navigate('/sme/wizard/5')
  }

  return (
    <Section>
      <Container>
        <StepsContent step={4}>
          <Steps icon="briefcase" />

          <InsuranceInfo />

          <Step4Form onSubmit={handleSubmit} />
        </StepsContent>
      </Container>
    </Section>
  )
}